import { Autoplay, Controller, EffectFade, Parallax, Navigation, Pagination, Swiper, FreeMode } from 'swiper'
// import { SwiperSlide } from 'swiper/react'
Swiper.use([Autoplay, Controller, EffectFade, Parallax, Navigation, Pagination, FreeMode]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

import './module/_hashScroll' // アンカーリンクスクロール
import './module/_spMenuToggle' // SPメニュー開閉

/* global  */ // tUrl等のグローバル変数を宣言する

import './_top.js'
import './_guide.js'
import './_contact.js'
import './_post.js'
import './_event.js'
import './_form.js'
import './_ajax.js'
import './_modal.js'
import './_destroy.js'
import './_hoverSync.js'

//  ##  ##     ##  ######             #####   #####    ####
//  ##  ####   ##    ##              ##   ##  ##  ##  ##
//  ##  ##  ## ##    ##    ########  ##   ##  #####    ###
//  ##  ##    ###    ##              ##   ##  ##  ##     ##
//  ##  ##     ##    ##               #####   #####   ####
// 画面に入った監視対象に.animatedを付加
// Intersection Observer
window.intObs = function () {
  if (!document.getElementsByClassName('js-in')[0]) {
    return
  }
  let rootMargin = '-10px 0px'
  let rootMarginLate = '-30% 0px'
  if (window.matchMedia('(max-width:768px)').matches) {
    //SPは検出を早くする
    rootMargin = '100px 0px'
    rootMarginLate = '100px 0px'
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const intObsOptionLate = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: rootMarginLate, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.querySelectorAll('.js-in:not(.animated)')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('active')
        if (entryItem.classList.contains('in-late')) {
          observerLate.unobserve(entryItem) // 監視対象から外す
        } else {
          observer.unobserve(entryItem) // 監視対象から外す
        }
      }
    }
  }
}
window.intObs() // 画面交差API起動

//   ####   ####            ######   #####    ####     ####    ##      #####
//  ##     ##                 ##    ##   ##  ##       ##       ##      ##
//   ###   ##     ########    ##    ##   ##  ##  ###  ##  ###  ##      #####
//     ##  ##                 ##    ##   ##  ##   ##  ##   ##  ##      ##
//  ####    ####              ##     #####    ####     ####    ######  #####
/**
 * @function scrollValToggle
 * @description スクロール量を基準にクラスを着脱する
 * @param {String} targetSelector ターゲットとする一意なセレクタ
 * @param {Number} scrollValStart 有効範囲となるスクロール量　上からの距離
 * @param {Number|Boolean} [scrollValEnd=false] 有効範囲外となるスクロール量　下からの距離
 * @param {String} toggleClass 切り替えるクラス名
 * @return {Void}
scrollValToggle('#hogeID', 500, false,'active')
*/
scrollValToggle('#header', 1, false, 'headerShift')

if (document.getElementById('topFix')) {
  const topFixPC = document.querySelector('#footer').offsetHeight
  const topFixSP = document.querySelector('.js-fv').offsetHeight
  scrollValToggle('#topFix', 0, topFixPC, 'pcShow')
  scrollValToggle('#topFix', topFixSP, false, 'spShow')
}

function scrollValToggle(targetSelector, scrollValStart = 500, scrollValEnd = false, toggleClass = 'active') {
  if (!document.querySelector(targetSelector)) {
    return
  }
  let isExecute = false // 実行中フラグ
  let scrollY = 0 // 縦方向のスクロール量
  const target = document.querySelector(targetSelector) // ターゲット要素
  let scToggleActive = false // ターゲット要素のONOFF状態
  document.addEventListener('scroll', function (ev) {
    scrollValToggleApply()
  })
  scrollValToggleApply() // 初回起動
  function scrollValToggleApply() {
    if (isExecute) {
      // 実行中ならスキップ
      return
    }
    isExecute = true
    // レンダリング準備が整ったら開始
    requestAnimationFrame(function () {
      scrollY = window.scrollY // スクロール量
      if (scrollY >= scrollValStart && !scToggleActive) {
        //トップから指定px以上スクロールしたらON
        target.classList.add(toggleClass)
        scToggleActive = true
      } else if (scrollY < scrollValStart && scToggleActive) {
        //スクロールが足りない時はOFF
        target.classList.remove(toggleClass)
        scToggleActive = false
      }
      if (scrollValEnd && scToggleActive) {
        // 終了ラインが設定されている場合は終了判定
        if (scrollY + window.innerHeight > document.documentElement.offsetHeight - scrollValEnd) {
          //スクロール終了範囲を過ぎていたらOFF
          target.classList.remove(toggleClass)
          scToggleActive = false
        }
      }
      isExecute = false
    })
  }
}

//  ##  ###    ###   ####               ####  ##      ##  ####    #####
//  ##  ## #  # ##  ##                 ##     ##      ##  ##  ##  ##
//  ##  ##  ##  ##  ##  ###  ########   ###   ##      ##  ##  ##  #####
//  ##  ##      ##  ##   ##               ##  ##      ##  ##  ##  ##
//  ##  ##      ##   ####              ####   ######  ##  ####    #####
// 画像汎用スライド
window.imgSlide = function () {
  const slideImg = new Swiper('.js-imgSlide:not(.setup)', {
    loop: true,
    speed: 1500,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    allowTouchMove: false,
    parallax: true,
    breakpoints: {
      769: {},
    },
  })

  setTimeout(() => {
    const slideList = document.getElementsByClassName('js-imgSlide')
    for (const element of slideList) {
      element.classList.add('setup')
    }
  }, 300)
}
window.imgSlide() // 画像汎用スライド実行
